const semanticClassNames = {
  root: 'lottie-embed',
} as const;

export default semanticClassNames;
